module.exports = __webpack_public_path__ + "fonts/VetoSansCond-BoldItalic.f6250117.eot";